<script lang="ts">
    import CN from "classnames";
    import { SvelteComponent } from "svelte";

    import Icon from "@components/Icon.svelte";

    export let className: string;
    export { className as class };
    export let variant:
        | "info"
        | "error"
        | "success"
        | "warning"
        | "flat"
        | "regular" = "info";
    export let icon: typeof SvelteComponent | undefined = undefined;
    export let backgroundColor: string | undefined = "#027a48";
    export let textColor: string | undefined = undefined;
    export let size: "lg" | "md" | "sm" = "md";
    export let bold: boolean | undefined = undefined;
    export let rounded: boolean | undefined = undefined;
    export let transparent = false;
    export let alignCenter = false;
</script>

<span
    class={CN(
        "gw-badge",
        className,
        `gw-badge--${variant}`,
        `gw-badge--${size}`,
        {
            "gw-badge--custom-bg": backgroundColor,
            "gw-badge--custom-text": textColor,
            "gw-badge--transparent": transparent,
            "gw-badge--bold": bold,
            "gw-badge--rounded": rounded,
            "gw-badge--align-center": alignCenter,
        }
    )}
    style="--gw-badge-bg-color: {backgroundColor}; --gw-badge-text-color: {textColor};"
>
    {#if icon}
        <Icon width="1.2em" height="1.2em">
            <svelte:component this={icon} />
        </Icon>
    {/if}
    <span>
        <slot />
    </span>
</span>

<style lang="postcss">
    .gw-badge {
        display: inline-flex;
        align-items: flex-end;
        padding: 0.3em 0.4em;
        border-radius: 4px;
        column-gap: 0.4em;
        font-weight: 400;
        line-height: 1em;

        &--md {
            font-size: 12px;
        }

        &--sm {
            font-size: 10px;
        }
        &--lg {
            font-size: 14px;
        }

        &--info {
            background-color: #98f4f4;
            color: var(--gw-badge-text-color);
        }

        &--warning {
            background-color: #e7aa04;
            color: #fff8e5;
        }

        &--success {
            background-color: #0fcc9d;
            color: #e5fff9;
        }

        &--error {
            background-color: #eb4757;
            color: #ffebed;
        }

        &--flat {
            background-color: none;
            padding-left: 0;
            padding-right: 0;
        }

        &--regular {
            font-weight: 400;
            line-height: normal;
            padding: 0;
        }

        &--custom-bg {
            background-color: var(--gw-badge-bg-color);
        }

        &--custom-text {
            color: var(--gw-badge-text-color);
            letter-spacing: normal;
        }

        &--transparent {
            background-color: transparent;
        }

        &--bold {
            font-weight: bold;
        }

        &--rounded {
            border-radius: 50%;
        }

        &--align-center {
            align-items: center;
        }
    }
</style>
